/* ============================================================
   fc-map-pin - the Falconclaw map pin, as one shared file.

   The shape is Ivo's Figma teardrop, 200 x 267, and it is the SAME shape the
   cart's shipping hub draws: FC_PIN_VIEWBOX, FC_PIN_PATH and pinHtml() in
   assets/fc-cart-hub.js (v15 item 2, v17 item 3). It is copied here so a
   product page can draw the pin without pulling the whole cart bundle in.

   FOLLOW-UP, when fc-cart-hub.js is next opened: delete its own copy of the
   two constants and the builder and load this file instead. Until that
   happens the two copies must be changed together, and THIS file is the one
   to change first.

   The builder is deliberately dumb: it takes a spec and returns markup.
   Colour, the inner dot and the sizing belong to the caller and to CSS.
   ============================================================ */
(function () {
  'use strict';

  var VIEWBOX = '0 0 200 267';
  var PATH =
    'M89.7229 261.613C14.0469 151.768 0 140.495 0 100.125C0 44.8273 44.7714 0 ' +
    '100 0C155.229 0 200 44.8273 200 100.125C200 140.495 185.953 151.768 ' +
    '110.277 261.613C105.311 268.796 94.6885 268.795 89.7229 261.613Z';

  /* The head of that path is a circle of radius 100 centred on (100, 100), so
     an inner dot is centred there too. */
  var DOT_CX = 100;
  var DOT_CY = 100;

  /* Only a plain hex colour is ever written into the inline fill. Anything
     else falls back, so a caller can never push a declaration through it. */
  function colour(v, fallback) {
    return /^#[0-9a-f]{3,8}$/i.test(String(v || '')) ? String(v) : fallback;
  }

  /* spec: { body, dot, dotR, selected }
     body  teardrop fill, dot  inner dot fill (omit for no dot),
     dotR  dot radius in viewBox units (default 34), selected  adds is-sel. */
  function html(spec) {
    var s = spec || {};
    var body = colour(s.body, '#222629');
    var dot = '';
    if (s.dot) {
      var r = typeof s.dotR === 'number' && s.dotR > 0 ? s.dotR : 34;
      dot =
        '<circle class="fcmp-pin__dot" cx="' + DOT_CX + '" cy="' + DOT_CY +
        '" r="' + r + '" style="fill:' + colour(s.dot, '#0e1411') + '"/>';
    }
    return (
      '<span class="fcmp-pin' + (s.selected ? ' is-sel' : '') + '">' +
      '<span class="fcmp-pin__s">' +
      '<svg class="fcmp-pin__bg" viewBox="' + VIEWBOX +
      '" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<path class="fcmp-pin__body" style="fill:' + body + '" d="' + PATH + '"/>' +
      dot +
      '</svg>' +
      '</span></span>'
    );
  }

  window.FCMapPin = { VIEWBOX: VIEWBOX, PATH: PATH, html: html };
})();
